'use client';

import useTranslation from 'next-translate/useTranslation';
import { Flex, Text } from '@eqi-investimentos/react';
import { eqiPlusContent } from '@/config/cms/eqiPlusContent';
import { ServiceCard } from './Card';
export const SpecialContentsWidget = () => {
  const {
    t
  } = useTranslation('common');
  return <Flex flexDir="column" gap="l" w="full" data-sentry-element="Flex" data-sentry-component="SpecialContentsWidget" data-sentry-source-file="index.tsx">
      <Text color="content.primary" fontSize="lg" fontWeight="normal" lineHeight="h6" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {t('widgets.ExclusiveServicesWidget.title')}
      </Text>
      <Flex w="full" gap="12" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {eqiPlusContent.map((props, idx) => {
        if (window.location.pathname === props.path) {
          return null;
        }
        return <ServiceCard key={idx} {...props} />;
      })}
      </Flex>
    </Flex>;
};